import { Phone, Calendar, Clock, CheckCircle, X } from 'lucide-react';

interface CallbackConfirmationProps {
  confirmationNumber: string;
  day: string;
  date: string;
  time: string;
  reason: string;
  onDismiss: () => void;
}

export default function CallbackConfirmation({
  confirmationNumber,
  day,
  date,
  time,
  reason,
  onDismiss
}: CallbackConfirmationProps) {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[200] animate-fade-in">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl transform transition-all animate-scale-in">
        {/* Close button */}
        <button
          onClick={onDismiss}
          className="absolute top-4 right-4 p-1 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Success icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-green-500" />
          </div>
        </div>

        <h2 className="text-xl font-semibold text-center mb-2 text-gray-800">
          Terugbelafspraak bevestigd!
        </h2>

        <p className="text-gray-500 text-center text-sm mb-6">
          Een medewerker belt je op het afgesproken moment.
        </p>

        {/* Appointment details */}
        <div className="bg-gray-50 rounded-xl p-4 space-y-3 mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-rose-100 flex items-center justify-center">
              <Calendar className="w-5 h-5 text-rose-500" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Datum</p>
              <p className="font-medium text-gray-800 capitalize">{day} {date}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
              <Clock className="w-5 h-5 text-blue-500" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Tijd</p>
              <p className="font-medium text-gray-800">{time}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
              <Phone className="w-5 h-5 text-purple-500" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Referentienummer</p>
              <p className="font-medium text-gray-800 font-mono">{confirmationNumber}</p>
            </div>
          </div>
        </div>

        {/* Reason if provided */}
        {reason && (
          <p className="text-xs text-gray-400 text-center mb-4">
            Onderwerp: {reason}
          </p>
        )}

        <button
          onClick={onDismiss}
          className="w-full bg-gradient-to-r from-rose-500 to-rose-600 text-white rounded-xl py-3 font-medium hover:from-rose-600 hover:to-rose-700 transition-all shadow-lg hover:shadow-xl"
        >
          Sluiten
        </button>
      </div>
    </div>
  );
}
